// import "firebase/compat/auth";
// import firebase from "firebase/compat/app";

import { getFirestore } from "@firebase/firestore";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const isDevelopment = window.location.hostname === 'localhost';
let firebaseConfig;

if(isDevelopment) {
  firebaseConfig = {
    apiKey: "AIzaSyAqbnI8QK9qi6veR7PB-L8suh7Y5AgXLiU",
    authDomain: "vartalabhdev.firebaseapp.com",
    projectId: "vartalabhdev",
    storageBucket: "vartalabhdev.appspot.com",
    messagingSenderId: "417744423171",
    appId: "1:417744423171:web:ffec7c5130c0393dcf4136"
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyCCCYBZW6LV_hjCELuGBoFMzvxz2QNuXgE",
    authDomain: "vartalabh-e2e5d.firebaseapp.com",
    projectId: "vartalabh-e2e5d",
    storageBucket: "vartalabh-e2e5d.appspot.com",
    messagingSenderId: "505851549379",
    appId: "1:505851549379:web:6f27e1a2ecac067350f476",
    measurementId: "G-1GSW90KEL8"
  };
}



const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);

export { auth, app, db, storage };
